module.exports = __webpack_public_path__ + "media/images/recruitment/landing/img_feature02-3b26ebcb103a4ed0d6634794fc122a28.png";